(function () {
'use strict';

angular.module('hyresgastApp').directive('hyTableau', hyTableau);

/**
 * @typedef TableauColumn
 * @property {string} title
 * @property {string} column
 * @property {number} type
 */

function hyTableau($location, $timeout, $document,
  HelperService, CommonIds) {
  return {
    restrict: 'E',
    transclude: {
      //vanliga namn listade här eftersom det är mycket komplicerat att arbeta med godtyckliga med bara transclude: true
      slot1: '?slot1',
      slot2: '?slot2',
      slot3: '?slot3',
      array: '?array',
      array2: '?array2',
      date1: '?date1',
      date2: '?date2',
      boolean1: '?boolean1',
      boolean2: '?boolean2',
      hyra: '?hyra',
      hyra2: '?hyra2',
      person: '?person',
      comment: '?comment',
      type: '?type',
      status: '?status',
    },
    templateUrl: 'components/tableau/tableau.html',
    scope: {
      columns: '=',
      filtersOverride: '=',
      defaultSorting: '@',

      lastParams: '=?',

      inMemory: '=',
      inMemoryExcessiveLimit: '=',
      checkboxes: '=',
      checkboxesAlternative: '=',
      selectedRows: '=',

      fGetData: '&',
      fPostprocessData: '&',

      limit: '=',
      noSorting: '=',
      noFiltering: '=',
      noPagination: '=',

      fRowClick: '&',
      useUrl: '=',

      idProperty: '@',

      infoText: '@',
      attributes: '=',

      actions: '=?',

      fGetContextInfo: '&',
      contextActions: '=?',
    },
    
    link: (scope) => {

      let init = new tableau.Init(scope, CommonIds.tableauAllId, $location);
      let util = new tableau.Utils(scope, $timeout);

      scope.uuid = crypto.randomUUID();

      const tickedOptionAll = 'Alla';
      const tickedOptionChecked = 'Vald';
      const tickedOptionUnchecked = 'Avvald';

      scope.ready = false;
      scope.offset = 0;
      scope.total = 0;
      scope.initReady = false;
      scope.hasSelectedRows = false;

      scope.rowClass = item => {
        let classes = scope.attributes
          ? scope.attributes.filter(x => x.column ? item[x.column] : x.fn(item)).map(x => x.class)
          : [];
        let readyClass = scope.ready ? '' : 'table__tr--muted';
        return classes.concat(readyClass).join(' ');
      };
      scope.columnClass = column => {
        return column.columnClass ? column.columnClass : '';
      }

      // eslint-disable-next-line no-unused-vars
      scope.$watchGroup(['fGetData', 'columns', 'inMemory', 'inMemoryExcessiveLimit'], newData => {
        if (init.maybeInit()) {
          getData();
        }
      });

      scope.$watch('checkboxes', newData => {
        if (scope.data && newData === true) {
          initCheckboxes();
          setSelectedRows();
        }
      });

      let sortingOrFilteringChanged = () => {
        if (!scope.inMemory) {
          getData(true);
        } else {
          scope.applyFilter();
        }
      };
      if (scope.useUrl) {
        scope.$on('$routeUpdate', sortingOrFilteringChanged);
      } else {
        scope.$watch('sortColumn', () => { scope.timed(sortingOrFilteringChanged) });
        scope.$watch('sortDirection', () => { scope.timed(sortingOrFilteringChanged) });
      }

      let setSelectedRows = () => {
        scope.selectedRows = scope.data.filter(x => scope.ticked[x[scope.idProperty]] === true);
        let disabledAttributes = scope.attributes ? scope.attributes.filter(x => x.disabled) : [];
        let disabledCheck = disabledAttributes.length
          ? scope.selectedRows.every(x => disabledAttributes.some(y => !x[y.column]))
          : true;
        scope.hasSelectedRows = (scope.selectedRows.length > 0) && disabledCheck;
      }
      scope.applyTickedFilterDropdown = () => {
        scope.offset = 0;
        scope.filters = { ticked: scope.filters.ticked };
        util.timed(() => { scope.applyFilter('ticked') });
      };
      scope.tick = () => {
        util.timed(() => { setSelectedRows(); });
      };
      scope.toggle = all => {
        let array = all ? scope.data : scope.filteredData;

        let arrayTicked = array.filter(x => scope.ticked[x[scope.idProperty]]);
        let newValue = arrayTicked.length < array.length;
        array.forEach(x => scope.ticked[x[scope.idProperty]] = newValue);

        util.timed(() => { setSelectedRows(); });
      };
      scope.isFiltered = () => {
        if (scope.filteredData) {
          return scope.filteredData.length < scope.data.length;
        } else {
          return false;
        }
      };
      scope.getFilteredTickedTotal = () => {
        if (scope.filteredData) {
          return scope.filteredData.filter(x => scope.ticked[x[scope.idProperty]]).length;
        }
      };
      scope.getFilteredStateTitle = all => {
        if (!scope.checkboxes || !scope.ticked) {
          return '';
        }
        return all
          ? scope.selectedRows && (scope.selectedRows.length < scope.total)
          : (scope.getFilteredTickedTotal() < scope.getTotal()) ? 'Markera' : 'Avmarkera';
      };
      scope.getTotal = () => {
        if (scope.inMemory && scope.filteredData) {
          return scope.filteredData.length;
        } else {
          return scope.total;
        }
      };
      scope.applyFilterTimed = columnKey => {
        $timeout(() => scope.applyFilter(columnKey), 100);
      }
      scope.applyFilter = columnKey => {
        if (scope.inMemory) {
          scope.offset = 0;
          if (!scope.data) {
            scope.data = [];
          }
          if (!scope.filters) {
            scope.filters = {};
          }
          let filterKeys = Object.keys(scope.filters).filter(k => scope.filters[k]);
          scope.filteredData = scope.data.filter(x => {
            let pass = true;
            filterKeys.filter(x => x !== 'ticked').forEach(k => {
              let column = scope.columns.find(c => c.column === k);
              let type = column.filterType;
              let filterValue = scope.filters[k];
              let dataValue = util.getX(x, k);
              // eslint-disable-next-line no-undefined
              if (dataValue == null) {
                pass = false;
                return;
              }
              if (filterValue) {
                if (column.type === 'array' && dataValue instanceof Array) {
                  pass &= dataValue.some(d => {
                    return column.ffn
                      ? column.ffn(d, filterValue)
                      : util.filterCmp(d, filterValue);
                  });
                } else if (type !== 'none' && filterValue) {
                  pass &= (column.ffn
                    ? column.ffn(dataValue, filterValue)
                    : util.filterCmp(dataValue, filterValue));
                }
              }
            });
            if (scope.checkboxes) {
              let checkedOnly = scope.filters.ticked === tickedOptionChecked;
              let uncheckedOnly = scope.filters.ticked === tickedOptionUnchecked;
              let isTicked = scope.ticked[x[scope.idProperty]];
              if (checkedOnly) {
                pass &= isTicked;
              }
              if (uncheckedOnly) {
                pass &= !isTicked;
              }
            }
            return pass;
          });
          scope.filteredData = scope.filteredData.sort(HelperService.dynamicSortSwe(scope.sortColumn, scope.sortDirection));
          scope.setDataVM();
          if (scope.checkboxes) {
            setSelectedRows();
          }
        } else {
          if (scope.useUrl) {
            let newData = {};
            if (columnKey) {
              newData[columnKey] = scope.filters[columnKey];
              let column = scope.columns.find(c => c.column === columnKey);
              if (column.lookup) {
                newData[columnKey] = util.castProperty(newData[columnKey], column.lookup.idProperty, true);
              }
            }
            $location.search(angular.extend($location.search(), newData));
          } else {
            sortingOrFilteringChanged();
          }
        }
      };
      let applyFilterOrUrl = (clear) => {
        if (scope.useUrl) {
          if (clear) {
            let viewParam = $location.search().view;
            $location.search({});
            //tabval bör stanna kvar
            if (viewParam !== undefined) {
              $location.search('view', viewParam);
            }
          }
          $location.search(angular.extend($location.search(), { order: scope.sortColumn, direction: scope.sortDirection }));
        } else {
          scope.applyFilter();
        }
      };

      scope.flipPage = function () {
        if (scope.inMemory) {
          scope.setDataVM();
        } else {
          getData();
        }
      };
      // eslint-disable-next-line no-unused-vars
      scope.$on("refresh", function (event, data) {
        scope.filteredData = null;
        if (data) {
          scope.filters = data;
        } else {
          scope.filters = {};
        }
        getData(true);
      });

      scope.setDataVM = function () {
        if (scope.inMemory) {
          let data = scope.filteredData ? scope.filteredData : scope.data;
          scope.dataVM = data ? data.slice(scope.offset, scope.offset + scope.limit) : [];
        } else {
          scope.dataVM = scope.data;
        }
      };

      let initCheckboxes = () => {
        if (scope.checkboxes && scope.idProperty) {
          if (scope.checkboxesAlternative) {
            scope.ticked = {};
            scope.selectedRows = [];
          } else {
            scope.ticked = scope.data.reduce(util.reductor, {});
            scope.selectedRows = scope.data;
          }
          scope.tickedFilterItems = [tickedOptionAll, tickedOptionChecked, tickedOptionUnchecked];
          scope.filters.ticked = tickedOptionAll;
        }
      }

      let getData = filterMode => {
        if (!scope.initReady) {
          return;
        }

        if (filterMode) {
          scope.offset = 0;
        }

        let params = {
          limit: scope.inMemory ? scope.inMemoryExcessiveLimit : scope.limit,
          offset: scope.inMemory ? 0 : scope.offset,
          direction: scope.sortDirection,
          order: scope.sortColumn,
        };

        let filters = scope.columns.reduce((acc, column) => {
          let key = column.column;
          if (scope.filters[key]) {
            if (column.lookup) {
              let value = util.castProperty(scope.filters[key], column.lookup.idProperty, false);
              if (value !== CommonIds.tableauAllId) {
                acc[`filters[${key}]`] = value;
              }
            } else {
              acc[`search[${key}]`] = scope.filters[key];
            }
          }
          return acc;
        }, {});

        Object.assign(params, filters);

        // eslint-disable-next-line no-undef
        scope.lastParams = structuredClone(scope.inMemory ? scope.filters : params);

        scope.ready = false;
        let tuAsPromis = scope.fGetData()(params);
        if (tuAsPromis.$promise) {
          tuAsPromis = tuAsPromis.$promise;
        }
        tuAsPromis.then(response => {
          scope.ready = true;
          scope.data = response.rows;
          scope.total = response.count;
          initCheckboxes();
          scope.applyFilter();
          scope.setDataVM();
          if (scope.fPostprocessData && scope.fPostprocessData()) {
            scope.fPostprocessData()(scope.data);
          }
          scope.timed(() => scope.$apply());
        });
      };

      scope.getFilterType = column => {
        if (column.filterType) {
          if (column.filterType === 'none') return null;
          return 'text';
        }
        if (!column.type) {
          return column.lookup
            ? (column.lookup.multi ? 'multicombobox' : 'combobox')
            : 'text';
        }
        if (['boolean'].includes(column.type)) return 'combobox';
        if (['array', 'date'].includes(column.type)) return 'text';
        if (['star'].includes(column.type)) return null;
      };
      scope.filtersActive = () => scope.filters
        ? Object.entries(scope.filters).filter(x => (x[0] !== 'ticked') && x[1]).length > 0
        : false;
      scope.clearFilters = () => {
        scope.filters = {};
        if (scope.checkboxes) {
          scope.filters.ticked = tickedOptionAll;
        }
        applyFilterOrUrl(true);
      };
      scope.getLookupValue = (item, column) => {
        let value = column.lookup.dictionary.find(x => x[column.lookup.idProperty] === item[column.column]);
        if (value) {
          return value[column.lookup.textProperty];
        }
        return null;
      };
      scope.itemSelected = (item, column) => {
        if (!column.template && scope.fRowClick && scope.fRowClick()) {
          scope.fRowClick()(item);
        }
      };
      scope.isColumnSortable = columnKey => !!columnKey && !!scope.sortColumns && !!scope.sortColumns.find(c => c.column === columnKey);
      scope.columnClick = column => {
        if (!scope.isColumnSortable(column.column)) {
          return;
        }
        let isSameColumn = (scope.sortColumn === column.column);
        if (isSameColumn) {
          scope.sortDirection = (scope.sortDirection === 'ASC') ? 'DESC' : 'ASC';
        } else {
          scope.sortColumn = column.column;
          scope.sortDirection = 'ASC';
        }
        applyFilterOrUrl();
      };
      scope.doAction = action => { action.action() };
    },
  }
}
})();